// extracted by mini-css-extract-plugin
module.exports = {"sectionTable":"styles_sectionTable__Bb6hG","subtitle":"styles_subtitle__AzE7J","description":"styles_description__oKzPT"};